var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { computed } from 'vue';
import { ActionEnum } from '@common/graphql/operations';
import { useRouter } from 'vue-router';
import { StudentsStore } from '@school/modules/store';
import { useEventBus } from '@vueuse/core';
import { ChatStore } from '@common/stores';
import { schoolBalanceActionsArray, schoolPartnerActionsArray, schoolPlansActionsArray, studentTableActionsArray } from '@common/components/Notifications/helpers/actionsByCategoryArrays';
import { EventBusEnum } from '@common/enums/eventBus.enum';
var SchoolRouteNameEnum;
(function (SchoolRouteNameEnum) {
    SchoolRouteNameEnum["HOME"] = "home";
    SchoolRouteNameEnum["COURSE"] = "course";
    SchoolRouteNameEnum["COURSE_SETTINGS"] = "courseSettings";
    SchoolRouteNameEnum["COURSE_CONSTRUCTOR"] = "courseConstructor";
    SchoolRouteNameEnum["STUDENTS"] = "students";
    SchoolRouteNameEnum["STUDENTS_COURSE"] = "studentsCourse";
    SchoolRouteNameEnum["STUDENTS_GROUP"] = "studentsGroup";
    SchoolRouteNameEnum["SCHOOL_HOMEWORKS"] = "schoolHomeworks";
    SchoolRouteNameEnum["SCHOOL_PAYMENTS"] = "schoolSettingsPaymentGateways";
    SchoolRouteNameEnum["BALANCE"] = "balance";
    SchoolRouteNameEnum["PLANS"] = "plans";
    SchoolRouteNameEnum["PARTNER"] = "profilePartner";
    SchoolRouteNameEnum["WEBINAR"] = "WebinarTranslation";
})(SchoolRouteNameEnum || (SchoolRouteNameEnum = {}));
export var useSchoolNotificationRedirect = function (notificationAction, notificationMeta) {
    var router = useRouter();
    var busShowCourseModules = useEventBus(EventBusEnum.SHOW_COURSE_MODULES);
    var schoolRouteName = computed(function () {
        if (schoolBalanceActionsArray.includes(notificationAction))
            return SchoolRouteNameEnum.BALANCE;
        if (schoolPlansActionsArray.includes(notificationAction))
            return SchoolRouteNameEnum.PLANS;
        if (schoolPartnerActionsArray.includes(notificationAction))
            return SchoolRouteNameEnum.PARTNER;
        if (studentTableActionsArray.includes(notificationAction))
            return SchoolRouteNameEnum.STUDENTS;
        if (notificationAction === ActionEnum.ActionWebinarUpcomingStreamSpeaker)
            return SchoolRouteNameEnum.WEBINAR;
        if (notificationAction === ActionEnum.ActionSchoolSettingsDiscountExpired)
            return SchoolRouteNameEnum.SCHOOL_PAYMENTS;
        if (notificationAction === ActionEnum.ActionCourseAccessGroupStudentLimitOver)
            return SchoolRouteNameEnum.STUDENTS_GROUP;
        if (notificationAction === ActionEnum.ActionHomeworkStudentSent)
            return SchoolRouteNameEnum.SCHOOL_HOMEWORKS;
        if (notificationAction === ActionEnum.ActionHomeworksStudentsSentCron)
            return SchoolRouteNameEnum.SCHOOL_HOMEWORKS;
        if (notificationAction === ActionEnum.ActionCourseUpcomingWebinarTeacher)
            return SchoolRouteNameEnum.COURSE_CONSTRUCTOR;
        return SchoolRouteNameEnum.HOME;
    });
    var schoolRouteParams = computed(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        if ([SchoolRouteNameEnum.COURSE_SETTINGS, SchoolRouteNameEnum.STUDENTS_COURSE].includes(schoolRouteName.value)) {
            return { courseId: (_a = notificationMeta.course) === null || _a === void 0 ? void 0 : _a.id };
        }
        if (schoolRouteName.value === SchoolRouteNameEnum.COURSE_CONSTRUCTOR) {
            return { courseId: (_b = notificationMeta.course) === null || _b === void 0 ? void 0 : _b.id, lessonId: (_c = notificationMeta.lesson) === null || _c === void 0 ? void 0 : _c.uuid };
        }
        if (schoolRouteName.value === SchoolRouteNameEnum.STUDENTS_GROUP) {
            return { course: (_d = notificationMeta.course) === null || _d === void 0 ? void 0 : _d.id, group: (_e = notificationMeta.group) === null || _e === void 0 ? void 0 : _e.id };
        }
        if (schoolRouteName.value === SchoolRouteNameEnum.SCHOOL_HOMEWORKS) {
            return { uuid: (_f = notificationMeta.homeworkUser) === null || _f === void 0 ? void 0 : _f.uuid };
        }
        if (schoolRouteName.value === SchoolRouteNameEnum.WEBINAR) {
            return { streamId: (_g = notificationMeta.stream) === null || _g === void 0 ? void 0 : _g.id };
        }
        return {};
    });
    var openStudentProfile = function () { return __awaiter(void 0, void 0, void 0, function () {
        var mappedStudent, selectedCourse;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!((_a = notificationMeta.student) === null || _a === void 0 ? void 0 : _a.id)) return [3 /*break*/, 2];
                    return [4 /*yield*/, StudentsStore.getStudent((_b = notificationMeta.student) === null || _b === void 0 ? void 0 : _b.id)];
                case 1:
                    _d.sent();
                    mappedStudent = StudentsStore.mappedStudent;
                    selectedCourse = mappedStudent === null || mappedStudent === void 0 ? void 0 : mappedStudent.courses.find(function (course) { var _a; return course.id === ((_a = notificationMeta.course) === null || _a === void 0 ? void 0 : _a.id); });
                    if (selectedCourse) {
                        StudentsStore.showStudentProfile((_c = notificationMeta.student) === null || _c === void 0 ? void 0 : _c.id);
                        busShowCourseModules.emit(selectedCourse);
                    }
                    _d.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var openChat = function () {
        ChatStore.show();
    };
    var goToRoute = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(notificationAction === ActionEnum.ActionCourseStudentFinishCourse)) return [3 /*break*/, 2];
                    return [4 /*yield*/, openStudentProfile()];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
                case 2:
                    if (notificationAction === ActionEnum.ActionChatStudentWaitAnswer_24Hour) {
                        openChat();
                        return [2 /*return*/];
                    }
                    if (!(notificationAction === ActionEnum.ActionHomeworkStudentSent || notificationAction === ActionEnum.ActionHomeworksStudentsSentCron)) return [3 /*break*/, 4];
                    return [4 /*yield*/, router.push({ name: schoolRouteName.value, query: { uuid: (_a = notificationMeta.homeworkUser) === null || _a === void 0 ? void 0 : _a.uuid } })];
                case 3:
                    _b.sent();
                    return [2 /*return*/];
                case 4: return [4 /*yield*/, router.push({ name: schoolRouteName.value, params: schoolRouteParams.value })];
                case 5:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return {
        goToRoute: goToRoute
    };
};
